<template>
  <div class="record-info-wrap">
    <div v-if="errmsg" class="err-message">{{errmsg}}</div>
    <div class="record-info" v-if="current">
      <div class="title clear">
        <div class="title-item emphatically">病历号: {{current.historySn}}</div>
        <div class="title-item emphatically" v-if="current.hospitalized === 1">床号: {{current.bedid}}</div>
      </div>
      <div class="sub-title">
        {{hospital ? hospital.name : current.hname}}-{{current.orgName}}-{{current.hospitalized === 1 ? '住院' : '门诊'}}
      </div>
      <div class="nav clear">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item>
            <el-button type="text" @click="currentRecord(cindex - 1)" :disabled="cindex === 0">上一份病历</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="currentRecord(cindex + 1)" :disabled="cindex === recordList.length - 1">下一份病历</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="more()" :disabled="recordList.length > 3">更多病历</el-button>
          </el-form-item>
          <el-form-item>
            <span>({{cindex + 1}}/{{recordList.length}})</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import PermissionUtils from '@/utils/permission'
  import RecordService from '@/request/record/record'
  export default {
    name: "RecordPatientRecord",
    props: {
      record: {
        type: Object,
        required: true
      },
      patient: {
        type: Number,
        required: true
      },
      hospital: Object,
      hasOperation: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        errmsg: null,
        recordLoading: false,
        recordList: [],
        cindex: 0,
        cid: _.isEmpty(this.record) ? 0 : this.record.id ,
        current: {},
        now: moment().valueOf()
      }
    },
    computed: {},
    created: function () {
      this.listRecord()
    },
    watch: {
      patient (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.listRecord();
        }
      },
      record: {
        deep: true,
        handler () {
          if (_.isEmpty(this.record)) {
            return
          }
          if (this.cid !== this.record.id) {
            this.currentRecord()
            return
          }
          if (!_.isEqual(this.record, this.current)) {
            _.assign(this.current, this.record)
          }
        }
      }
    },
    methods: {
      hasPermission (sns) {
        return PermissionUtils.hasPermission(sns, this.$store.getters.permissions, false)
      },
      listRecord () {
        if (!this.patient) {
          this.recordList = []
          return
        }
        this.recordLoading = true
        RecordService.list({
          sort: 'admissionDate',
          order: 'desc',
          patient: this.patient
        }).then(res => {
          if (!res['result'] || _.isEmpty(res['result'])) {
            this.errmsg = '此患者没有病历'
            return
          }
          this.errmsg = null
          this.recordList = _.concat([], res['result'])
          this.currentRecord()
        }).catch(err => {
          if (!_.isEmpty(err)) {
            this.errmsg = err.message
          } else {
            this.errmsg = '获取患者病历列表出错'
          }
        }).finally(() => {
          this.recordLoading = false
        })
      },
      currentRecord (index) {
        if (_.isEmpty(this.recordList)) {
          this.current = {}
          this.cindex = 0
          return
        }
        if (!_.isUndefined(index)) {
          this.cindex = index
        } else if (_.isEmpty(this.record)) {
          this.cindex = 0
        } else {
          this.cindex = _.findIndex(this.recordList, r => {
            return r['id'] === this.record.id
          })
          if (this.cindex < 0) {
            this.cindex = 0
          }
        }
        this.current = this.recordList[this.cindex]
        if (_.isEmpty(this.record) || this.record.id !== this.current['id']) {
          this.cid = this.current['id']
          this.$emit('change-record', this.cid)
        } else if (this.cid !== this.current['id']) {
          this.cid = this.current['id']
        }
      },
      more() {
        this.$emit('more', this.patient)
      },
      handlerClickTool(name) {
        this.$emit('tool', name, this.current)
      }
    },
    filters: {}
  }
</script>

<style scoped>
  .title {
    line-height: 33px;
  }
  .title .emphatically {
    font-weight: bold;
    font-size: 24px;
  }
  .title .title-item {
    float: left;
    margin-right: 50px;
  }
  .sub-title {
    color: #8e8e93;
  }
  .record-info {
    position: relative;
  }
  .nav {
    position: absolute;
    top: 0px;
    right: 0px;
  }
</style>
